export interface FacebookRegister {
  firstName: string;
  lastName: string;
  emailAddress: string;
  userSocialID: string;
  accessToken: string;
  socialProviderType: SocialProviderType;
}

export enum SocialProviderType {
  Facebook = 1,
  Google = 2,
  Apple = 3
}
